// Generated by purs version 0.13.8
"use strict";
var Affjax = require("../Affjax/index.js");
var Affjax_RequestBody = require("../Affjax.RequestBody/index.js");
var Affjax_ResponseFormat = require("../Affjax.ResponseFormat/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HTTP_Method = require("../Data.HTTP.Method/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Lunarbox_Api_Endpoint = require("../Lunarbox.Api.Endpoint/index.js");
var Lunarbox_Data_Profile = require("../Lunarbox.Data.Profile/index.js");
var Lunarbox_Data_Utils = require("../Lunarbox.Data.Utils/index.js");
var Routing_Duplex = require("../Routing.Duplex/index.js");
var Get = (function () {
    function Get() {

    };
    Get.value = new Get();
    return Get;
})();
var Post = (function () {
    function Post(value0) {
        this.value0 = value0;
    };
    Post.create = function (value0) {
        return new Post(value0);
    };
    return Post;
})();
var Put = (function () {
    function Put(value0) {
        this.value0 = value0;
    };
    Put.create = function (value0) {
        return new Put(value0);
    };
    return Put;
})();
var Delete = (function () {
    function Delete() {

    };
    Delete.value = new Delete();
    return Delete;
})();
var BaseUrl = (function () {
    function BaseUrl(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    BaseUrl.create = function (value0) {
        return function (value1) {
            return new BaseUrl(value0, value1);
        };
    };
    return BaseUrl;
})();
var defaultRequest = function (v) {
    return function (v1) {
        var v2 = (function () {
            if (v1.method instanceof Get) {
                return new Data_Tuple.Tuple(Data_HTTP_Method.GET.value, Data_Maybe.Nothing.value);
            };
            if (v1.method instanceof Post) {
                return new Data_Tuple.Tuple(Data_HTTP_Method.POST.value, v1.method.value0);
            };
            if (v1.method instanceof Put) {
                return new Data_Tuple.Tuple(Data_HTTP_Method.PUT.value, v1.method.value0);
            };
            if (v1.method instanceof Delete) {
                return new Data_Tuple.Tuple(Data_HTTP_Method.DELETE.value, Data_Maybe.Nothing.value);
            };
            throw new Error("Failed pattern match at Lunarbox.Api.Request (line 50, column 23 - line 54, column 35): " + [ v1.method.constructor.name ]);
        })();
        return {
            method: new Data_Either.Left(v2.value0),
            url: v.value0 + (Routing_Duplex.print(Lunarbox_Api_Endpoint.endpointCodec)(v1.endpoint) + (function () {
                if (v.value1) {
                    return "?pretty";
                };
                return "";
            })()),
            content: Data_Functor.map(Data_Maybe.functorMaybe)(Affjax_RequestBody.json)(v2.value1),
            username: Data_Maybe.Nothing.value,
            password: Data_Maybe.Nothing.value,
            withCredentials: true,
            responseFormat: Affjax_ResponseFormat.json,
            headers: [  ]
        };
    };
};
var decodeJsonResponse = function (res) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Bifunctor.lmap(Data_Either.bifunctorEither)(Affjax.printError)(res))(function (response) {
        if (response.status >= 200 && response.status <= 299) {
            return Control_Applicative.pure(Data_Either.applicativeEither)(response.body);
        };
        return Control_Bind.bindFlipped(Data_Either.bindEither)(Data_Either.Left.create)(Lunarbox_Data_Utils.decodeAt(Data_Argonaut_Decode_Class.decodeJsonString)("message")(response.body));
    });
};
var requestJson = function (dictMonadAff) {
    return function (baseUrl) {
        return function (opts) {
            return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(Effect_Aff_Class.liftAff(dictMonadAff)(Affjax.request(defaultRequest(baseUrl)(opts))))(function (res) {
                return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(decodeJsonResponse(res));
            });
        };
    };
};
var register = function (dictMonadAff) {
    return function (baseUrl) {
        return function (fields) {
            return Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1())(requestJson(dictMonadAff)(baseUrl)({
                endpoint: Lunarbox_Api_Endpoint.Register.value,
                method: Post.create(Data_Maybe.Just.create(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Profile.encodeJsonEmail)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Profile.encodeJsonUsername)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                    return "username";
                }))())(new Data_Symbol.IsSymbol(function () {
                    return "password";
                }))())(new Data_Symbol.IsSymbol(function () {
                    return "email";
                }))())())(fields)))
            }))(function (response) {
                return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(Data_Functor.voidLeft(Data_Either.functorEither)(response)({
                    isAdmin: false,
                    username: fields.username
                }));
            });
        };
    };
};
var requestUser = function (dictMonadAff) {
    return function (baseUrl) {
        return function (opts) {
            return Data_Functor.mapFlipped(((((dictMonadAff.MonadEffect0()).Monad0()).Bind1()).Apply0()).Functor0())(requestJson(dictMonadAff)(baseUrl)(opts))(function (v) {
                return Control_Bind.bind(Data_Either.bindEither)(v)(Lunarbox_Data_Utils.decodeAt(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Profile.decodeJsonUsername)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                    return "username";
                }))()())(new Data_Symbol.IsSymbol(function () {
                    return "isAdmin";
                }))()())())("user"));
            });
        };
    };
};
var login = function (dictMonadAff) {
    return function (baseUrl) {
        return function (fields) {
            return requestUser(dictMonadAff)(baseUrl)({
                endpoint: Lunarbox_Api_Endpoint.Login.value,
                method: Post.create(Data_Maybe.Just.create(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Profile.encodeJsonEmail)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                    return "password";
                }))())(new Data_Symbol.IsSymbol(function () {
                    return "email";
                }))())())(fields)))
            });
        };
    };
};
var profile = function (dictMonadAff) {
    return function (baseUrl) {
        return requestUser(dictMonadAff)(baseUrl)({
            endpoint: Lunarbox_Api_Endpoint.Profile.value,
            method: Get.value
        });
    };
};
module.exports = {
    Get: Get,
    Post: Post,
    Put: Put,
    Delete: Delete,
    BaseUrl: BaseUrl,
    defaultRequest: defaultRequest,
    login: login,
    register: register,
    profile: profile,
    requestJson: requestJson,
    decodeJsonResponse: decodeJsonResponse,
    requestUser: requestUser
};
